import { Select } from "antd"
import React from "react"

const SelectPackageCycle = ({
  placeholder = "Chọn thời hạn gói cước",
  value,
  onChange,
  disabled,
  style = { height: "36px" },
}) => {
  return (
    <Select
      placeholder={placeholder}
      title="Loại hình SIM"
      allowClear
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={style}
    >
      <Select.Option value="1 ngày">1 ngày</Select.Option>
      <Select.Option value="3 ngày">3 ngày</Select.Option>
      <Select.Option value="5 ngày">5 ngày</Select.Option>
      <Select.Option value="7 ngày">7 ngày</Select.Option>
      <Select.Option value="10 ngày">10 ngày</Select.Option>
      <Select.Option value="15 ngày">15 ngày</Select.Option>
      <Select.Option value="20 ngày">20 ngày</Select.Option>
      <Select.Option value="25 ngày">25 ngày</Select.Option>
      <Select.Option value="30 ngày">30 ngày</Select.Option>
    </Select>
  )
}

export default SelectPackageCycle
